import { api } from './client';
import type { ChannelHealthResponse, FunnelResponse, SlaMetricsResponse } from './types';

export interface RangeFilters {
  from?: string;
  to?: string;
}

export function getFunnel(
  filters: RangeFilters & { group_by?: 'channel' | 'agent' | 'scenario_version' },
): Promise<FunnelResponse> {
  return api.get<FunnelResponse>('/api/v1/analytics/funnel', filters as Record<string, string | undefined>);
}

export function getChannelsHealth(): Promise<ChannelHealthResponse> {
  return api.get<ChannelHealthResponse>('/api/v1/analytics/channels/health');
}

export function getSlaMetrics(filters: RangeFilters): Promise<SlaMetricsResponse> {
  return api.get<SlaMetricsResponse>('/api/v1/analytics/sla', filters as Record<string, string | undefined>);
}
